






























import Vue from 'vue';
import Component from 'vue-class-component';

import router from '../router/index';

import SidebarInst from '../services/sidebar';

@Component
export default class Tags extends Vue {
  sidebar = SidebarInst;

  public goToNote(uuid: string) {
    router.push({name: 'note-id', params: {uuid}});
  }

  public goToSearch(searchType: string, tag: string) {
    router.push({name: 'search', query: {[searchType]: tag}}).catch(err => {});
  }
}
